module.exports = __webpack_public_path__ + "img/fallback.4e8218a7.svg";